import { useQuery } from 'react-query'
import axios from 'axios'
import { API_URL } from '../../config'
import { rqDefaultOptions } from './defaultOptions'

const getAllVendors = async (inputObj) => {
  const { limit, skip, email } = inputObj.queryKey[1]
  axios.defaults.headers.common['Authorization'] = email
  const allVendorsAPIPath = `${API_URL}/api/vendor/v1/getAllVendors?limit=${limit}&skip=${skip}`
  const res = await axios.get(allVendorsAPIPath)
  return res.data
}

export function useAllVendors(queryKey, limit = 20, skip = 0, email) {
  const options = {
    ...rqDefaultOptions,
  }
  return useQuery([queryKey, { limit, skip, email }], getAllVendors, options)
}
